import { cn } from "@/lib/utils";
import { type ReactNode } from "react";

/** Divided list in a bordered, muted card: the container of `KeyValueRow`s. */
export default function RowsCard({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex flex-col divide-y divide-border overflow-hidden rounded-xl border border-border bg-muted/30 px-3",
        className,
      )}
    >
      {children}
    </div>
  );
}
